import type { CreateAdminPaymentMethodInput } from "../utils/zod/admin";
import mercadoPagoLogo from "../assets/paymentGateways/mercadopago.svg";
import flowLogo from "../assets/paymentGateways/flow.svg";

export interface GatewayPaymentMethodPreset {
  name: string;
  key: string;
  provider: string;
  description: string;
  ticketConfig: CreateAdminPaymentMethodInput["ticketConfig"];
  logo?: string;
}

export const GATEWAY_PAYMENT_METHODS: GatewayPaymentMethodPreset[] = [
  {
    name: "MercadoPago - Checkout Pro",
    key: "mercadopago_link",
    provider: "mercadopago",
    description:
      "Link de pago único (no recurrente). El cliente paga en MercadoPago. Expira en 48 horas.",
    ticketConfig: {
      plan: { requires: false },
      food: { requires: false },
      merchandise: { requires: false },
    },
    logo: mercadoPagoLogo,
  },
  {
    name: "Flow",
    key: "flow_link",
    provider: "flow",
    description:
      "Link de pago único. El cliente paga via Webpay, Servipag, MACH y mas.",
    ticketConfig: {
      plan: { requires: false },
      food: { requires: false },
      merchandise: { requires: false },
    },
    logo: flowLogo,
  },
];

/**
 * Espeja detectGatewayProvider del backend: el provider vive en el prefijo de
 * la key del metodo de pago (`mercadopago_link` → `mercadopago`).
 */
export function detectGatewayProvider(paymentMethodKey: string): string | null {
  return (
    GATEWAY_PAYMENT_METHODS.find((m) =>
      paymentMethodKey.startsWith(`${m.provider}_`),
    )?.provider ?? null
  );
}
